import React, { useState, useEffect } from 'react';
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Spinner,
    Button,
    FormGroup,
    Label,
    Input,
    CardFooter,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Alert
} from "reactstrap";
import { useNavigate } from 'react-router-dom';

function ConnectInsuranceService() {

    const [loading, setLoading] = useState(true);
    const [insuranceoperator, setInsuranceoperator] = useState('');
    const [insuranceoperatoroptions, setInsuranceoperatoroptions] = useState([]);
    const [submitloading, setSubmitloading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false); // State for modal
    const [modalMessage, setModalMessage] = useState(''); // State for modal message

    const [error, setError]=useState(false)
    const [message, setMessage]=useState(true)

    const token = useSelector((state) => state.userLogin.userInfo.token);
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
            i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                };

                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/insurance-operator-list/`, config);
                setInsuranceoperatoroptions(response.data);

            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData(); 
    }, [token]);

    const toggleModal = () => setModalOpen(!modalOpen); // Function to toggle modal

    const submit = async(e) => {
        setSubmitloading(false);

        if (insuranceoperator==='') {
            setMessage(t('The insurance operator is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setSubmitloading(true);
            return;
        } 

        try {
            const config = {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            };

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/synchronize-normal-user-insurance-profile/${insuranceoperator}/`, config);

            if (response.status === 201) {
                setModalMessage(t('Your request to link your devices with the insurance company has been sent. The insurance operator will receive your request soon, and then we will let you know if the insurance company accept the link'));
                toggleModal();
            } else {
                setModalMessage(t('Something went wrong. Please try again.'));
                toggleModal();
            }
        } catch(error) {
            console.error(error);
            setModalMessage(t('An error occurred while sending the request.'));
            toggleModal();
        } finally {
            setSubmitloading(true);
        }
    };

    const navigatebutton = async(e) => {
        navigate("/connect-insurance-service/")
    }

    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):( 
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t('Agricultural Insurance linkup')}</h3>
                                </CardHeader>
                                <CardBody>
                                    <FormGroup>
                                        <Label for="insuranceOperatorSelect">{t('Select the insurance operator to link up')}</Label>
                                        <Input 
                                            type="select" 
                                            id="insuranceOperatorSelect"
                                            onChange={(e) => setInsuranceoperator(e.target.value)} 
                                            value={insuranceoperator}>
                                                <option key={""} value={""}>
                                                    {t('Select an operator')}
                                                </option>
                                                {insuranceoperatoroptions.map((farmer, index) => (
                                                    <option key={index} value={farmer.user}>
                                                        {farmer.name_insurance_company} - {farmer.operator_name} {farmer.operator_surname}
                                                    </option>
                                                ))}
                                        </Input>
                                    </FormGroup> 
                                    {error && <Alert  color="danger" fade={false}>{message}</Alert >}
                                </CardBody>
                                <CardFooter>
                                    {submitloading ? (
                                            <>
                                                <Button className="my-4" color="success" type="button" onClick={submit}>
                                                    {t("Ask to link your devices to the insurance operator")} <i className="fa-solid fa-link"></i>
                                                </Button>
                                            </>
                                        ):(
                                            <>
                                                <Button color="success" disabled>
                                                    <Spinner size="sm">
                                                        {t("Sending your request...")}
                                                    </Spinner>
                                                    <span>
                                                        {' '}{t("Link your request...")}
                                                    </span>
                                                </Button>
                                            </>
                                    )}
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )}

            {/* Modal Component */}
            <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{t('Notification')}</ModalHeader>
                <ModalBody>
                    {modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={navigatebutton}>{t('Close')}</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default ConnectInsuranceService;
